import { cme_kurs } from './Global/Kurs'
import { jumpToCoursePart } from './Global/functions'
import { mainVideo } from './Global/Video'

import './../css/powerpoint-overlay.css'


export const PowerPointOverlay = ({ slides, courseIndex, setCourseIndex, setCurrentVideoTime, slidesAmount }) => {
    return (
        <>
            {/* ----- overlay for video controls ----- */}
            < div className="presentation-overlay powerpoint-overlay overlay-active" onClick={() => mainVideo.toggleOverlay()} >

                {/* select course part */}
                < div className="course-parts-container" onClick={(e) => (e.stopPropagation())}>
                    {
                        Array.apply(null, Array(cme_kurs.partsAmount)).map((item, index) => (

                            // if there are more parts display this
                            (cme_kurs.partsAmount > 1) ?
                                <div
                                    key={"part-reiter-" + index}
                                    active={(index === courseIndex) ? "true" : "false"}
                                    onClick={() => jumpToCoursePart(index, setCourseIndex, setCurrentVideoTime)}
                                    className="reiter">
                                    Teil {index + 1}
                                </div>

                                : <div key={"part-reiter-" + index}></div >
                        ))
                    }
                </div >


                {/* main video controls */}
                < div className="vc_container_inner_dark" >
                    <div className="container">

                        {/* current chart */}
                        <div className="vc_container_20 chart_nr_active-container">
                            <div className="formated-video-time float-start d-none d-lg-block"><b className="chart_nr_active">1</b> von {slidesAmount}</div>
                        </div>

                        {/* fullscreen */}
                        <div className="vc_container_20 fullscreen-btn-container">
                            <div className="vc_icon float-end vc_icon_fullscreen" onClick={(e) => mainVideo.toggleFullScreen(e)}></div>
                        </div>


                        {/* previous chart */}
                        <div className="vc_container_20">
                            <div className="vc_icon_prev vc_icon float-end" onClick={(e) => mainVideo.gotoPrevChart(e, slides, courseIndex)}></div>
                        </div>

                        {/* next chart */}
                        <div className="vc_container_20">
                            <div className="vc_icon_next vc_icon float-start" onClick={(e) => mainVideo.gotoNextChart(e, slides, courseIndex)}></div>
                        </div>


                    </div>
                </div >

            </div >
        </>
    )
}

export default PowerPointOverlay